module.exports = __webpack_public_path__ + "2534e0f5be7e736244e445cfe2e79128.svg";